import { router } from "expo-router";
import { useEffect } from "react";
import {
  handoffRoute,
  readHandoffToken,
  stripHandoffToken,
} from "@utils/handoff/handoffUrl";

/**
 * Web variant (app.lissen.com) of the hand-off landing. A Live Link
 * open-in-app link for a signed-in visitor arrives here through the
 * open.lissen.com redirect with `?h=<token>` on the content URL (the native
 * build reads the same param in +native-intent). Strip it from the address
 * bar first — it is an exchangeable credential and must not survive a copied
 * URL — then let the one receiver (/auth/handoff) sign in and deliver the
 * content as `next`.
 */
const HandoffLandingHandler = () => {
  useEffect(() => {
    const { pathname, search, hash } = window.location;
    const token = readHandoffToken(search);
    if (!token) return;
    const next = stripHandoffToken(`${pathname}${search}${hash}`);
    window.history.replaceState(window.history.state, "", next);
    router.replace(handoffRoute(token, next) as never);
  }, []);

  return null;
};

export default HandoffLandingHandler;
